/** Release only slides needed by navigation, not every hidden banner at once. */
export function releaseHeroImages(root: HTMLElement, index: number, includePrevious = false) {
  const slides = root.querySelectorAll<HTMLElement>('[data-hero-slide]');
  if (!slides.length || !Number.isInteger(index) || index < 0 || index >= slides.length) return;
  const needed = [index, (index + 1) % slides.length];
  if (includePrevious) needed.push((index - 1 + slides.length) % slides.length);
  for (const i of new Set(needed)) {
    // Real src/srcset stay in server HTML. Only the inert source is removed.
    slides[i].querySelectorAll('[data-hero-pending]').forEach(source => source.remove());
  }
}
